/* eslint-disable no-debugger */
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Icon, { ExclamationCircleOutlined } from "@/utils/antdIcon";
import { Collapse, Modal } from "antd";
import { BatchDownloadItem, ErrorCode, Status } from "../BatchDownloadPanel/type";
import {
  getSuccessDownloadTaskCount,
  getGlobalStatus,
  checkDownloadError
} from "../BatchDownloadPanel/BasisComponents/utils";
import PanelHeader from "../BatchDownloadPanel/BasisComponents/PanelHeader";
import Header from "../BatchDownloadPanel/BasisComponents/Header";
import List from "../BatchDownloadPanel/BasisComponents/Main";
import { CancelIcon, UpIcon } from "../BatchDownloadPanel/BasisComponents/Icons";
import GroupSpaceDownloadController from "./BatchDownloadController";
import events from "../../context/events";
import { btnAction } from "../BatchDownloadPanel/config/btn.aciton";
import "../BatchDownloadPanel/index.less";
import GlobalContext from "@/context/GlobalContext";

interface IProps {
  className?: string;
  gid?: string;
}

const { Panel } = Collapse;
let index = 0;
const GroupDownloadCollapsePanel = (props: IProps) => {
  const { className = "", gid } = props;
  const DownloadService: any = GroupSpaceDownloadController.getInstance();
  const [activeKey, setActiveKey] = useState<any>();
  const { onLine } = useContext(GlobalContext);
  const [list, setList] = useState<BatchDownloadItem[]>(DownloadService?.getGidByTaskQueue(gid));
  DownloadService.proxy(setList);
  DownloadService.setGid(gid);
  // 添加任务&开始任务下载
  const addTaskList = useCallback(
    (newTaskList) => {
      for (let item of newTaskList) {
        item.gid = gid;
      }
      DownloadService.setGid(gid);
      // console.log(newTaskList, 'newTaskListnewTaskListnewTaskList');
      DownloadService.addTask([...newTaskList], () => {
        let downloadList = DownloadService?.getGidByTaskQueue(gid);
        setList([...downloadList]);
        setActiveKey("download");
        events.emit("handleGroupUploadPanel", true);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gid]
  );
  const handleDownloadPanel = useCallback((isUploadExpand) => {
    isUploadExpand && setActiveKey("");
  }, []);
  useEffect(() => {
    events.on("handleGroupDownload:addTaskList", addTaskList);
    events.on("handleGroupDownloadPanel", handleDownloadPanel);
    return () => {
      events.removeListener("handleGroupDownload:addTaskList", addTaskList);
      events.removeListener("handleGroupDownloadPanel", handleDownloadPanel);
    };
  }, [addTaskList, handleDownloadPanel]);
  const cancelPanel = useCallback(
    () => {
      index = 0;
      DownloadService.clearGidByTask(gid);
      setActiveKey("");
      setList([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [list, gid]
  );
  // 关闭面板和折叠面板
  const genExtra: any = useCallback(() => {
    const tmpList = list.filter((item: BatchDownloadItem) => item.gid === gid);
    return (
      <div>
        <span
          className={
            activeKey === "download"
              ? "collapse-icon collapse-down-icon"
              : "collapse-icon collapse-up-icon"
          }
        >
          <Icon component={UpIcon} />
        </span>
        <span
          className="collapse-cancel-icon"
          onClick={(event: any) => {
            event.stopPropagation();
            if (
              tmpList.some(
                (item: BatchDownloadItem) =>
                  item.status === Status.PROGRESS || item.status === Status.WAITING
              )
            ) {
              Modal.confirm({
                title: "取消下载",
                icon: <ExclamationCircleOutlined />,
                content: "下载尚未完成，要取消所有的下载吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                  cancelPanel();
                }
              });
              return;
            }
            cancelPanel();
            // cancelPanel(event);
          }}
        >
          <Icon component={CancelIcon} />
        </span>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, list, gid]);
  const { currentSuccessTaskCount, totalTaskCount, gloadlStatus } = useMemo(() => {
    let tmpList = list.filter((item: BatchDownloadItem) => item.gid === gid);
    let currentSuccessTaskCount = getSuccessDownloadTaskCount(tmpList);
    let totalTaskCount = tmpList.length;
    let gloadlStatus = getGlobalStatus(tmpList);
    return { currentSuccessTaskCount, totalTaskCount, gloadlStatus };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, onLine, gid]);
  return (
    <Collapse
      className={className + " collapse-box"}
      bordered={false}
      accordion={true}
      activeKey={activeKey ? [activeKey] : []}
      onChange={(key) => {
        // console.log(key, 'keykeykeykeykeykeykey');
        setActiveKey(key);
        events.emit("handleGroupUploadPanel", Boolean(key));
      }}
    >
      {/* 批量下载 */}
      {list.length > 0 && (
        <Panel
          showArrow={false}
          header={
            <PanelHeader
              status={gloadlStatus}
              currentSuccessTaskCount={currentSuccessTaskCount}
              totalTaskCount={totalTaskCount}
            />
          }
          key="download"
          extra={genExtra()}
        >
          <Header
            status={gloadlStatus}
            currentSuccessTaskCount={currentSuccessTaskCount}
            totalTaskCount={totalTaskCount}
            handleCancelAll={() => {
              DownloadService.handleTaskCancelAll(gid);
            }}
            handleRetryAll={() => {
              DownloadService.handleTaskRetryAll(gid);
            }}
          />
          <List
            list={list.filter((item: BatchDownloadItem) => item.gid === gid)}
            callback={(item: BatchDownloadItem) => {
              // item.options.onStarted(item);
              let applyFn = Status.ERROR;
              if (item.status === Status.PROGRESS || item.status === Status.WAITING) {
                applyFn = Status.CANCEL;
              } else if (item.status === Status.CANCEL || item.status === Status.RETRY) {
                applyFn = Status.RETRY;
              } else if (item.status === Status.SUCCESS) {
                applyFn = Status.SUCCESS;
              } else {
                applyFn = Status.ERROR;
              }
              btnAction[applyFn](DownloadService, item, onLine ? index++ : index);
            }}
          />
        </Panel>
      )}
    </Collapse>
  );
};

export default GroupDownloadCollapsePanel;
